import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {ConfirmationDialogService} from '../../dialog/confirmation/confirmation-dialog.service';

@Component({
  selector: 'app-delete-item-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule],
  templateUrl: './delete-item-button.component.html',
})
export class DeleteItemButtonComponent {
  private readonly confirmDialogService = inject(ConfirmationDialogService);

  headerKey = input<string>('confirmationDialog.deleteItem.header');
  messageKey = input<string>('confirmationDialog.deleteItem.text');
  testId = input<string>('delete-item-button');

  delete = output<void>();

  protected onClick(event: MouseEvent): void {
    event.stopPropagation();

    this.confirmDialogService.confirm({
      headerKey: this.headerKey(),
      messageKey: this.messageKey(),
      accept: () => {
        this.delete.emit();
      },
    });
  }
}
